function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import r from "../managers/braze-instance.js";
import { getAlias as Yt } from "../managers/utils.js";
import { isObject as yt } from "../util/code-utils.js";
import { convertMsToSeconds as O, timestampOrNow as Zt } from "../util/date-utils.js";

var ve = /*#__PURE__*/function () {
  function ve(t, s, i, r, e) {
    _classCallCheck(this, ve);

    this.userId = t, this.type = s, this.time = i, this.sessionId = r, this.data = e, this.userId = t, this.type = s, this.time = Zt(i), this.sessionId = r, this.data = e;
  }

  _createClass(ve, [{
    key: "Nr",
    value: function Nr() {
      var t;
      var s = {
        name: this.type,
        time: O(this.time),
        data: this.data || {},
        session_id: this.sessionId
      };
      null != this.userId && (s.user_id = this.userId);
      var i = (null === (t = r.Sr()) || void 0 === t ? void 0 : t.jh()) || !1;

      if (!s.user_id && !i) {
        var _t = Yt(r.j());

        _t && (s.alias = _t);
      }

      return s;
    }
  }, {
    key: "bt",
    value: function bt() {
      return {
        u: this.userId,
        t: this.type,
        ts: this.time,
        s: this.sessionId,
        d: this.data
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ve(t.user_id, t.name, t.time, t.session_id, t.data);
    }
  }, {
    key: "RE",
    value: function RE(t) {
      return null != t && yt(t) && null != t.t && "" !== t.t;
    }
  }, {
    key: "Rn",
    value: function Rn(t) {
      return new ve(t.u, t.t, t.ts, t.s, t.d);
    }
  }]);

  return ve;
}();

export { ve as default };